module.exports = __webpack_public_path__ + "img/uk_flag.dd2cd107.svg";